import React, { useEffect, useState } from 'react';
import Slider1Img from '../../Files/Slider1_First_Brick_Images.png';
import Slider1Video from '../../Files/Slider1_First_Brick_Video.mp4';
import '../../CSS/Global.css';
import HomeFeatureCategory from './HomeFeatureCategory';
import HomeProperty from './HomeProperty';
import HomeAbout from './HomeAbout';
import HomeCategoryCarousel from './HomeCategoryCarousel';
import HomeAdvertisement from './HomeAdvertisement';
import EnquiryFormModal from '../Forms/EnquiryFormModal';
import HomeDevelopers from './HomeDevelopers';

const slides = [
  {
    title: 'Sarfare Properties Residences',
    subtitle: 'Kandivali East, Mumbai',
  },
  {
    title: 'STAROM SEJAL',
    subtitle: 'Malad West, Mumbai',
  },
  {
    title: 'Viceroy Savana',
    subtitle: 'Kandivali East , Mumbai',
  },
];

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlide, setPrevSlide] = useState(null);
  const [animating, setAnimating] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("popup_shown");

    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 30000); // 30 seconds

      return () => clearTimeout(timer);
    }
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true);
      setPrevSlide(currentSlide);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 1000); // match animation duration
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const { title, subtitle } = slides[currentSlide];

  return (
    <>
      <div className="home-slider-first-brick">
        <div className="home-slider-list-first-brick">
          <div className="home-slider-list1-first-brick">
            <div className="home-slider-images-first-brick">

              {/* Old Slide Animating Out */}
              {animating && (
                <>
                  <img
                    src={Slider1Img}
                    alt="Old Slide"
                    className="home-slider-img-first-brick fade-out-up"
                  />
                  <video
                    src={Slider1Video}
                    className="home-slider-video-first-brick fade-out-down"
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                </>
              )}

              {/* New Slide Animating In */}
              {!animating && (
                <>
                  <img
                    src={Slider1Img}
                    alt="New Slide"
                    className="home-slider-img-first-brick fade-in-up"
                  />
                  <video
                    src={Slider1Video}
                    className="home-slider-video-first-brick fade-in-down"
                    autoPlay
                    muted
                    loop
                    playsInline
                  />
                </>
              )}
            </div>

            <div className="home-slider-details-first-brick">
              {animating ? (
                <>
                  <h1 className="home-slider-building-name-first-brick text-fade-out-up">{title}</h1>
                  <p className="home-slider-area-name-first-brick text-fade-out-down">{subtitle}</p>
                </>
              ) : (
                <>
                  <h1 className="home-slider-building-name-first-brick text-fade-in-up">{title}</h1>
                  <p className="home-slider-area-name-first-brick text-fade-in-down">{subtitle}</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <HomeAdvertisement />
      <HomeAbout />
      <HomeCategoryCarousel />
      <HomeFeatureCategory />
      <HomeDevelopers />
      <HomeProperty />


      <EnquiryFormModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          sessionStorage.setItem("popup_shown", "true");
        }}
        source="Homepage"
        user_id="HBTR0003"
      />

    </>
  );
}

export default Home;
